import React, { useEffect, useState } from 'react';
import {
  IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon,
  IonModal, IonTitle, IonToolbar,
} from '@ionic/react';
import { checkmarkCircle, closeOutline } from 'ionicons/icons';
import { Exercise } from '../../../../datamodels';
import './ExerciseModal.css';

interface ExerciseModalProps {
  isOpen: boolean;
  machineTitle?: string;
  exercises: Exercise[];
  onConfirm: (exerciseName: string) => void;
  onCancel: () => void;
}

const ExerciseModal: React.FC<ExerciseModalProps> = ({ isOpen, machineTitle, exercises, onConfirm, onCancel }) => {
  const [selectedExercise, setSelectedExercise] = useState<string | null>(null);

  useEffect(() => {
    if (isOpen) setSelectedExercise(null);
  }, [isOpen]);

  return (
    <IonModal isOpen={isOpen} onDidDismiss={onCancel} initialBreakpoint={0.84} breakpoints={[0, 0.84, 1]} className="exercise-picker-modal">
      <IonHeader>
        <IonToolbar>
          <IonTitle>Choose exercise</IonTitle>
          <IonButtons slot="end"><IonButton aria-label="Close exercise picker" onClick={onCancel}><IonIcon icon={closeOutline} /></IonButton></IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent className="exercise-picker-content">
        <div className="exercise-picker-intro">
          <span>{machineTitle || 'Selected machine'}</span>
          <h2>What are you training?</h2>
          <p>Choose one movement so your workout and muscle statistics stay accurate.</p>
        </div>

        <div className="exercise-picker-list" role="radiogroup" aria-label="Exercises">
          {exercises.map((exercise, index) => {
            const selected = selectedExercise === exercise.name;
            return (
              <button type="button" role="radio" aria-checked={selected} className={`exercise-picker-card${selected ? ' is-selected' : ''}`} key={exercise.id || `${exercise.name}-${index}`} onClick={() => setSelectedExercise(exercise.name)}>
                <span className="exercise-picker-card__check">{selected && <IonIcon icon={checkmarkCircle} />}</span>
                <span className="exercise-picker-card__copy">
                  <strong>{exercise.name}</strong>
                  <span className="exercise-picker-card__muscles">
                    {(exercise.muscles || []).length
                      ? exercise.muscles.map(muscle => <i key={muscle}>{muscle}</i>)
                      : <i>Muscle focus not specified</i>}
                  </span>
                </span>
              </button>
            );
          })}
        </div>
      </IonContent>

      <IonFooter><IonToolbar><div className="exercise-picker-actions">
        <IonButton fill="clear" color="medium" shape="round" onClick={onCancel}>Cancel</IonButton>
        <IonButton shape="round" disabled={!selectedExercise} onClick={() => selectedExercise && onConfirm(selectedExercise)}>Add exercise</IonButton>
      </div></IonToolbar></IonFooter>
    </IonModal>
  );
};

export default ExerciseModal;
